<template>
    <div class="flex-form__inline">
        <span class="flex-form__inline-text">
            located at
        </span>

        <div class="flex-form__inline">
            <content-editable
                :class="getInvalidClass('targetProperty')"
                :value="dataNew.targetProperty"
                @input="onInput"
            />

            <tooltip>
                You can reference any property in the form response by entering <a href="https://restfulapi.net/json-jsonpath/" target="_blank">JSONPath</a> into this field.
            </tooltip>
        </div>
    </div>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'condition-target-form-response',
    mixins: [eventDataMixin],

    computed: {
        schema() {
            return {
                targetProperty: {
                    type: String,
                    default: '',
                    required: true,
                },
            };
        },
    },

    methods: {
        onInput(value) {
            this.dataNew.targetProperty = value;
        },
    },
};
</script>
